import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ObjectRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return { required: true };
        } else {
            if (Array.isArray(control.value) && control.value.length === 0) {
                return { required: true };
            }

            if (typeof control.value === 'object' && Object.keys(control.value).length === 0) {
                return { required: true };
            }
        }

        return null;
    };
}
